import { Component, OnInit, Input,ViewEncapsulation } from '@angular/core';
import { PortalInfo } from "app/shared/services/portal-info";
import * as emiGlobals from 'app/globals';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { EmiBaseInfoService } from "app/shared/services/emi-base-info.service";

@Component({
  selector: 'emi-footer',
  templateUrl: './emi-footer.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./emi-footer.component.css']
})
export class EmiFooterComponent implements OnInit {
  portalInfo;
  menu;
  constructor(
    private modalService: NgbModal,
    private baseInfoService:EmiBaseInfoService
  ) {
    this.getPortalInfo();
    baseInfoService.portalDataFetched$.subscribe(
    data => {
      this.getPortalInfo();
    });
  }

  domainurl =  emiGlobals._emisubdomainUrl;

  ngOnInit() {
    
  }

  open(content) {
    this.modalService.open(content, { windowClass: 'emi-contact' });
  }

  getPortalInfo(){
    if(localStorage.getItem(emiGlobals.portalInfo)&&localStorage.getItem(emiGlobals.portalInfo)!='undefined'){
      this.portalInfo = JSON.parse(localStorage.getItem(emiGlobals.portalInfo));
    }
    if(localStorage.getItem(emiGlobals.portalMenu)&&localStorage.getItem(emiGlobals.portalMenu)!='undefined'){
      this.menu = JSON.parse(localStorage.getItem(emiGlobals.portalMenu));
    }
  }
  gotoFb(){
     if(this.portalInfo.fb_url){
        window.location.href=this.portalInfo.fb_url;
     }
  }
  sendMail(){
    if(this.portalInfo.contact_email){
      window.location.href=this.portalInfo.contact_email;
  }
}

}



// WEBPACK FOOTER //
// ./src/app/shared/emi-footer/emi-footer.component.ts